import '../../styles/Footer.css';

/**
 * Represents the footer section of the website.
 */
function Footer() {

    return (
        <footer className='background'>
            <div className="footer-container">
                <div className="footer-left">
                    <img className="logo-JockSport" src={require("../../images/logo.png")} alt="company logo" />
                </div>
                <div className="footer-right">
                    <span className="teko title-footer">GAMBLE RESPONSIBLY.</span>
                    <p className="content-footer">
                        The content of this site is not intended to be a lure to gambling.
                        Instead, the information we present is meant for nothing more than
                        informational and entertainment purposes. JockSports.com is not
                        liable for any losses that are incurred or problems that arise at online
                        casinos or elsewhere after the reading and consideration of this site’s
                        content. If you are gambling online utilizing information from this site,
                        you are doing so completely and totally at your own risk.
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;